import Login from '@/modules/Auth/Login';
import style from './Login.module.scss';
import { Link } from 'react-router-dom';

function LoginPage() {
  return (
    <div className={style.login__page__container}>
      <Login />
      <div className={style.login__page__footer}>
        <Link
          to={'https://augmedix.com/terms-and-policies/#terms-of-use'}
          className={style.login__page__link}
          target="_blank"
        >
          Terms and Conditions
        </Link>
        <Link
          to={'https://augmedix.com/terms-and-policies/#terms-of-use'}
          className={style.login__page__link}
          target="_blank"
        >
          Privacy Policy
        </Link>
      </div>
    </div>
  );
}

export default LoginPage;
